import { Link } from '@tanstack/react-router';

export function NotFound() {
  return (
    <div className="mx-auto max-w-7xl px-6 py-16">
      <h1 className="text-2xl font-semibold">Page not found</h1>
      <p className="mt-2 text-slate-600">The route you requested doesn’t exist.</p>
      <Link to="/workspaces" className="btn-primary mt-6">
        Back to workspaces
      </Link>
    </div>
  );
}
